<template>
  <div>
    <v-skeleton-loader
        v-if="isLoading"
        :loading="true"
        type="heading"
        :class="skeletonClasses"
        width="100%"
    ></v-skeleton-loader>
    <h1
        v-else-if="!isLoading && level === 1"
        :class="classArray"
        :style="[styleObject, h1Styles]"
    >
      <slot>{{ text }}</slot>
    </h1>
    <h4
        v-else-if="!isLoading && level === 4"
        :class="classArray"
        :style="styleObject"
    >
      <slot>{{ text }}</slot>
    </h4>
    <h3
        v-else-if="!isLoading && level === 5"
        :class="classArray"
        :style="styleObject"
    >
      <slot>{{ text }}</slot>
    </h3>
  </div>
</template>


<!-- ATTENTION: you can't use <header> in vue templates with this component. Use <Header> with a capital H. -->

<script lang="ts">
import Vue from "vue"

export default Vue.extend({
  name: "Header",
  props: {
    text: String,
    level: { type: Number, default: 1 },
    customClass: { type: String, default: "" },
    customStyles: { type: Object, required: false },
    customSkeletonClass: { type: String, default: "" },
    bold: { type: Boolean, default: true },
    color: { type: String, default: "textColor" },
    isLoading: { type: Boolean, default: false },
  },
  computed: {
    setColor(): string | undefined {
      switch (this.color) {
        case "primary":
          return this.$vuetify.theme.themes.light.primary?.toString()
        case "textColor":
          return this.$vuetify.theme.themes.light.textColor?.toString()
        default:
          return this.color
      }
    },
    setFontWeight(): number {
      if (this.bold) {
        return 900
      }
      return 300
    },
    styleObject(): object {
      return {
        ...this.customStyles,
        color: this.setColor,
        fontWeight: this.setFontWeight,
        fontFamily: "system-ui !important",
      }
    },
    classArray(): string[] {
      return [`text-h${this.level} suus__header`, `${this.customClass}`]
    },
    skeletonClasses(): string[] {
      return [
        `suus__header__skeleton skeleton--${this.level}`,
        this.customSkeletonClass,
      ]
    },
    h1Styles(): object {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return {
            fontFamily: "system-ui !important",
            fontSize: "1.8rem !important",
            lineHeight: "2.4rem !important",
          }
        default:
          return {
            fontFamily: "system-ui !important",
            fontSize: "2.5rem !important",
            lineHeight: "3.5rem !important",
          }
      }
    },
  },
})
</script>

<style lang="sass">
.suus__header
  &__skeleton
    .v-skeleton-loader__heading
      width: 80%!important
      &.skeleton--1
        .v-skeleton-loader__heading
          height: 30px
          border-radius: 15px
</style>
